<template>
    <div class="row">
        <div class="col-12 col-sm pr-sm-0">
            <!-- @todo Add the validation rule "[\d-]{16,19}" -->
            <input class="form-control" type="text" autocomplete="off" aria-label="Search" placeholder="XXXX-XXXX-XXXX-XXXX" maxlength="19"
                   @keyup.enter="authByCode" v-model="authCode">
        </div>
        <div class="col-12 col-sm-auto pl-sm-0">
            <button class="btn btn-primary my-2 my-sm-0" @click="authByCode">Увійти</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'auth-by-code',
        data() {
            return {
                authCode: '',
            };
        },
        created() {
            window.authByCodeDebug = this;
        },
        methods: {
            authByCode() {
                let promise = this.$store.dispatch('authByCode', this.authCode);
                promise.then(() => {
                    // @note Отрабатывает до того как выполниться API запрос!!!
                    // console.log('then');
                });
                // location.href = '/'; // Чтобы обновился экран после логина
                //this.$router.push('/'); // Чтобы обновился экран после логина
            }
        }
    }
</script>

<style scoped>

</style>
